export const exchangeValueFromTranslation = (
  translation: string,
  valueName: string,
  value: string,
) => translation.replace(`%${valueName}%`, value);
